import createCrudService from '@core/api/create-crud-service';
import { QUERY_KEYS } from '@src/shared/constants/query-keys';

import type { TBaseQuery } from '@shared/types/base-query';
import type { TSubmission } from '@shared/types/submission';
import { stagesEndpoints } from '../pages/stages/services/endpoints';

export type TSubmissionQuery = {
  submitted_by: number | string;
  program: number | string;
  status: TSubmission['status'][];
  visa_status: TSubmission['visa_status'];
  priority: TSubmission['priority'];
  created_at_after: string;
  created_at_before: string;
} & TBaseQuery;

const submissionApi = createCrudService<TSubmission, TSubmissionQuery>({
  queryKey: [QUERY_KEYS.getSubmissions],
  url: 'submissions',
  validateQuery: [
    ...stagesEndpoints.rulesList.queryKey,
    QUERY_KEYS.getStagesProgress,
  ],
});

export default submissionApi;
